module.exports = __webpack_public_path__ + "static/img/1609_phase_function_Paper_PointsHejduk_Prediction.c6bc638.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1609_phase_function_Paper_PointsHejduk_Prediction.png
// module id = joM0
// module chunks = 0